<template>
    <div>
        <div v-if="isMini" class="ob1-color-chips ob1-color-chips-mini">
            <span class="visually-hidden">Groupe de couleurs disponibles non sélectionnables</span>
            <span
                v-for="color in colors"
                :key="'color-chips-mini-' + color.code"
                class="ob1-color-chip"
                :style="'background-color: ' + color.code +';'"
            >
                <span v-safe-html="color.colorName" class="ob1-color-chips-mini-tooltip" />
            </span>
        </div>
        <fieldset v-else class="ob1-color-chips">
            <legend class="visually-hidden">
                Coloris disponibles
            </legend>
            <template v-for="(color, index) in colors">
                <input
                    :id="id + '_' + color.inputName + '-' + index"
                    :key="'color-chips-input-' + color.code"
                    autocomplete="off"
                    type="radio"
                    :name="color.inputName"
                    class="ob1-color-chip-input"
                    :checked="isChecked(color) ? 'true' : null"
                    @click="onColorChipsChange(color)"
                >
                <label
                    :key="'color-chips-label-' + color.code"
                    :for="id + '_' + color.inputName + '-' + index"
                    class="ob1-color-chip-label"
                >
                    <span class="ob1-color-chip" :style="'background-color: ' + color.code +';'" />
                    <span v-safe-html="color.colorName" class="visually-hidden" />
                </label>
            </template>
        </fieldset>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {ColorChip} from "./models/ColorChip";

export default defineComponent({
    name: 'ColorChips',
    props: {
        id: {
            type: String,
            required: true
        },
        colors: {
            type: Array as () => Array<ColorChip>,
            required: true
        },
        selectedColor: {
            type: String,
            default: null
        },
        isMini: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isChecked(color: ColorChip): boolean {
            return color.code === this.selectedColor
        },
        onColorChipsChange(color: ColorChip): void {
            this.$emit('change', color);
        }
    }
});
</script>
